import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {createSelector} from "reselect";

import {topoUtils} from '../utils/topo-utils';
import {geoUtils} from '../utils/geo-utils';

const topo = topoUtils.getNationalTopography();

/**
 * Component for drawing the outline of the United States for the State map.
 *
 * @property height - height of the parent svg in pixels for placement
 * @property width - width of the parent svg in pixels for placement
 * @property fillColor - string hex color value for the drawn path fill def. #e8e8e8
 * @property strokeColor - string hex color value for the drawn path stroke def. #373737
 *
 * @example
 * return (
 *   <UsaOutline
 *     width={500}
 *     height={500}
 *   />
 * )
 */
export default class UsaOutline extends PureComponent {

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    fillColor: PropTypes.string,
    strokeColor: PropTypes.string
  };

  static defaultProps = {
    fillColor: '#e8e8e8',
    strokeColor: '#373737'
  }

  getWidth = (props) => props.width
  getHeight = (props) => props.height

  getPath = createSelector(
    [this.getWidth, this.getHeight],
    (width, height) => geoUtils.getAlbersUsaPath(width, height)
  )

  getStrokeWidth = createSelector(
    [this.getWidth],
    (width) => width > 500 ? 4 : 2.25
  )

  render() {
    const {fillColor, strokeColor} = this.props;
    const path = this.getPath(this.props);
    const strokeWidth = this.getStrokeWidth(this.props);

    return (
      <g className="UsaOutline">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillColor}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          d={path(topo.land)}
        />
      </g>
    )
  }
}
